import { Layout } from 'antd'
import appStore from 'assets/imgs/app-store.png'
import googlePlay from 'assets/imgs/google-play.png'
import { Link } from 'react-router-dom'
import styles from './footer.module.scss'
import { useAppSelector } from 'hooks'
import { OS_TYPE } from 'models/common'

const FooterPC: React.FC = () => {
  const { setting } = useAppSelector((s) => s.app)
  return (
    <Layout.Footer className={styles.footer_container}>
      <div className={styles.wrap}>
        <div>
          {setting.os_type.includes(OS_TYPE.IOS) && (
            <Link to={setting?.appstore_url} target="_blank">
              <img src={appStore}/>
            </Link>
          )}

          {setting.os_type.includes(OS_TYPE.ANDROID) && (
            <Link to={setting?.googleplay_url} target="_blank" style={{ marginLeft: '16px' }}>
              <img src={googlePlay}/>
            </Link>
          )}
        </div>
        {(setting.os_type.includes(OS_TYPE.IOS) || setting.os_type.includes(OS_TYPE.ANDROID)) && <p>ブラウザ版だけでなく、 iOSアプリやAndroidアプリでもご覧 いただけます。</p>}
      </div>

      <p>{setting?.copyright}</p>
    </Layout.Footer>
  )
}

export default FooterPC
